module.exports = __webpack_public_path__ + "img/zero_run.fbe6021b.jpeg";